import {Alert, Box, Chip, Skeleton, Stack, Typography} from '@mui/material'
import type {QueryDocumentSnapshot} from 'firebase/firestore'
import {getActiveCourseAccessDisabledWindow, isCourseArchived, type Course} from '@goschool/model'
import {useMemo} from 'react'
import {useInstructorNames} from '@goschool/dao'
import {useTranslation} from 'react-i18next'

export function CoursePageHeader({courseSnapshot}: { courseSnapshot: QueryDocumentSnapshot<Course> }) {
  const course = useMemo(
    () => courseSnapshot.data(),
    [courseSnapshot]
  )

  const instructorNames = useInstructorNames(courseSnapshot)
  const {t} = useTranslation()
  const activeDisabledWindow = useMemo(
    () => getActiveCourseAccessDisabledWindow(course),
    [course]
  )
  const disabledMessage = activeDisabledWindow?.message ?? t('course:status.temporarilyClosedDescription')

  return <Box flexGrow={0}>
    <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
      <Typography variant="h4" gutterBottom={false} component="h1">{course?.title ?? <Skeleton/>}&nbsp;
        <Typography variant="caption">{course?.code ?? <Skeleton/>}</Typography></Typography>
      {course != null && isCourseArchived(course) &&
        <Chip size="small" color="default" label={t('course:status.archived')}/>}
      {activeDisabledWindow != null &&
        <Chip size="small" color="warning" label={t('course:status.temporarilyClosed')}/>}
    </Stack>
    <Typography variant="subtitle1">{instructorNames ?? <Skeleton/>}</Typography>
    {activeDisabledWindow != null &&
      <Alert severity="warning" sx={{mt: 2}}>{disabledMessage}</Alert>}
  </Box>
}
